/* istanbul ignore file */
import {
    RECEIVE_BUILD_BOOKING,
    RECEIVE_RENTAL_CAR_CONTRACT,
} from '../actions/types'

const initialState = null

export default function errorReducer (state = initialState, action) {
    switch (action.type) {
        case RECEIVE_RENTAL_CAR_CONTRACT:
        case RECEIVE_BUILD_BOOKING:
            return action.status.error
        default:
            return state
    }
}
